var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonatiClever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 155,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#FFFFFF",
    d: "m128.2,129c-1.8,0 -3.5,-0.5 -5.1,-1.4l-25,-15.2l2.7,-4l25,15.2c2.1,1.3 5,0.7 6.3,-1.3l0,0c1.4,-2 0.7,-4.7 -1.4,-6.1l-0.1,-0.1l-38,-22.7l-7.1,0c-1.7,-0.1 -3.3,0.5 -4.4,1.6l-5.8,5.5c-3.7,3.6 -9.9,3.7 -13.7,0.1c-3.9,-3.6 -4.1,-9.6 -0.3,-13.3l0.2,-0.2l8.3,-7.5l6.4,0l-11.2,11.1c-1.8,1.8 -1.8,4.8 0.2,6.6c1.9,1.7 4.9,1.7 6.8,-0.1l5.8,-5.6c2.2,-2 5.1,-3.1 8.1,-3l8.4,0l39.4,23.5c4.4,2.8 5.7,8.5 2.8,12.7l-0.1,0.1c-2.1,2.7 -5.1,4.1 -8.2,4.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#FFFFFF",
    d: "m84.7,150.6c-1.8,0 -3.5,-0.5 -5.1,-1.4l-3.3,-1.9l2.5,-4.1l3.4,1.9c1.1,0.7 2.3,0.9 3.5,0.6c1.2,-0.3 2.2,-0.9 2.9,-1.9s0.9,-2.2 0.6,-3.3c-0.3,-1.1 -1,-2.1 -2,-2.7l-4.2,-2.6l2.7,-4l4.2,2.6c2.2,1.3 3.6,3.3 4.2,5.7c0.6,2.4 0.1,4.8 -1.3,6.9c-1.4,2.1 -3.5,3.5 -6,4c-0.7,0.1 -1.4,0.2 -2.1,0.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#FFFFFF",
    d: "m99.2,143.4c-1.8,0 -3.5,-0.5 -5.1,-1.4l-11.2,-6.8l2.7,-4l11.2,6.8c1,0.6 2.3,0.8 3.4,0.6s2.2,-0.9 2.9,-1.9c1.3,-2 0.7,-4.7 -1.4,-6l-11.2,-6.8l2.7,-4l11.2,6.8c4.4,2.7 5.8,8.4 3,12.6c-1.4,2.1 -3.5,3.5 -6,4c-0.8,0 -1.5,0.1 -2.2,0.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#FFFFFF",
    d: "m113.7,136.2c-1.8,0 -3.5,-0.5 -5.1,-1.4l-18.1,-11l2.7,-4l18.1,11c1,0.6 2.3,0.8 3.4,0.6c1.2,-0.3 2.2,-0.9 2.9,-1.9c1.3,-2 0.7,-4.7 -1.4,-6l-18.1,-11l2.7,-4l18.1,11c4.4,2.7 5.8,8.4 3,12.6c-1.4,2.1 -3.5,3.5 -6,4c-0.8,0 -1.5,0.1 -2.2,0.1",
    className: "st0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_7",
    fill: "#FFFFFF",
    points: "133.5,113.20000457763672 129,111.20000457763672 131.39999389648438,106.4000015258789 136.39999389648438,103.5999984741211 153.10000610351562,103.5999984741211 153.10000610351562,108.4000015258789 137.6999969482422,108.4000015258789 135.1999969482422,109.79999542236328 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#FFFFFF",
    d: "m36.5,117c-0.3,0 -0.6,0 -0.9,0.1c-1.1,0.2 -2,0.9 -2.6,1.8s-0.8,2 -0.6,3c0.2,1.1 0.9,2 1.8,2.5l0.3,0.2c0.9,0.6 2.1,0.8 3.2,0.5c1.1,-0.2 2,-0.9 2.6,-1.8c0.6,-0.9 0.8,-2 0.6,-3c-0.2,-1.1 -0.9,-2 -1.8,-2.5l-0.3,-0.2c-0.7,-0.4 -1.5,-0.6 -2.3,-0.6m0.3,13c-1.7,0 -3.4,-0.5 -4.9,-1.4l-0.3,-0.2c-2.1,-1.3 -3.5,-3.2 -4,-5.5s-0.1,-4.7 1.2,-6.6c2.7,-4.1 8.4,-5.3 12.7,-2.7l0,0l0.3,0.2c2.1,1.3 3.5,3.2 4,5.5s0.1,4.6 -1.2,6.6c-1.3,2 -3.4,3.3 -5.8,3.9c-0.7,0.1 -1.4,0.2 -2,0.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#FFFFFF",
    d: "m71.7,137.6c-1.4,0 -2.8,0.7 -3.6,1.9c-0.6,0.9 -0.8,2 -0.6,3c0.2,1.1 0.9,2 1.8,2.5l0.3,0.2c0.9,0.6 2.1,0.8 3.2,0.5c1.1,-0.2 2,-0.9 2.6,-1.8c0.6,-0.9 0.8,-2 0.6,-3c-0.2,-1.1 -0.9,-1.9 -1.8,-2.5l-0.3,-0.2c-0.7,-0.4 -1.5,-0.6 -2.2,-0.6m0.3,13.1c-1.7,0 -3.4,-0.5 -4.9,-1.4l-0.3,-0.2c-2.1,-1.3 -3.5,-3.2 -4,-5.5s-0.1,-4.6 1.2,-6.6c2.7,-4.1 8.4,-5.3 12.7,-2.7l0,0l0.3,0.2c4.3,2.6 5.5,8.1 2.8,12.1c-1.3,2 -3.4,3.3 -5.8,3.9c-0.7,0.1 -1.4,0.2 -2,0.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#FFFFFF",
    d: "m51.5,118.9c-0.3,0 -0.6,0 -1,0.1c-1.1,0.2 -2.1,0.9 -2.8,1.8l-3.2,4.8c-1.3,2 -0.7,4.6 1.3,5.8s4.8,0.7 6.1,-1.3l3.2,-4.8c0.6,-0.9 0.8,-2.1 0.6,-3.2c-0.3,-1.1 -0.9,-2 -1.9,-2.6c-0.7,-0.3 -1.5,-0.6 -2.3,-0.6m-3.3,18.1c-1.7,0 -3.5,-0.5 -5,-1.4c-4.4,-2.7 -5.6,-8.2 -2.9,-12.4l3.2,-4.8c1.3,-2 3.4,-3.4 5.9,-3.9c2.4,-0.5 5,-0.1 7.1,1.2s3.6,3.3 4.1,5.6s0.1,4.7 -1.3,6.8l-3.2,4.8c-1.7,2.6 -4.8,4.1 -7.9,4.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#FFFFFF",
    d: "m65.1,123c-0.3,0 -0.6,0 -1,0.1c-1.1,0.2 -2.1,0.9 -2.8,1.8l-5.2,7.9c-1.3,2 -0.7,4.6 1.3,5.8s4.8,0.7 6.1,-1.3l5.2,-7.9c0.6,-0.9 0.8,-2.1 0.6,-3.2c-0.3,-1.1 -0.9,-2 -1.9,-2.6c-0.7,-0.4 -1.5,-0.6 -2.3,-0.6m-5.3,21.1c-1.7,0 -3.5,-0.5 -5,-1.4c-4.4,-2.7 -5.6,-8.2 -2.9,-12.4l5.2,-7.9c1.3,-2 3.4,-3.4 5.9,-3.9c2.4,-0.5 5,-0.1 7.1,1.2s3.6,3.3 4.1,5.6s0.1,4.7 -1.3,6.8l-5.2,7.9c-1.7,2.6 -4.8,4.1 -7.9,4.1",
    className: "st0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_13",
    fill: "#FFFFFF",
    points: "31.599998474121094,114.4000015258789 29.300003051757812,109.70000457763672 26.199996948242188,108.20000457763672 11.199996948242188,108.20000457763672 11.199996948242188,103.4000015258789 27.300003051757812,103.4000015258789 33.099998474121094,106.0999984741211 36.099998474121094,112.4000015258789 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_14",
    fill: "#DE2327",
    height: 3.2,
    width: 33,
    className: "st1",
    y: 76.5,
    x: 62.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_15",
    fill: "#DE2327",
    height: 3.2,
    width: 18.3,
    className: "st1",
    y: 76.5,
    x: 40.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#DE2327",
    d: "m21.4,76.5c0,0.3 -0.1,0.5 -0.1,0.8l-0.2,1.6l-6.2,-0.6l0.2,-1.7l6.3,0c0.1,-0.7 0.2,-1.4 0.4,-2.1l-21.8,0l0,5.3l36.8,0l0,-3.2l-15.4,0l0,-0.1z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "svg_18",
    fill: "#DE2327",
    height: 3.2,
    width: 18.3,
    className: "st1",
    y: 76.5,
    x: 99.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#DE2327",
    d: "m155.9,74.4l-21.8,0c0.1,0.7 0.3,1.4 0.4,2.1l6.3,0l0.2,1.7l-6.2,0.6l-0.2,-1.6c0,-0.3 -0.1,-0.5 -0.1,-0.8l-13.2,0l0,3.2l34.7,0l-0.1,-5.2l0,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#DE2327",
    d: "m86.3,52.9c0,-3.9 -3.3,-7.1 -7.3,-7.1s-7.3,3.2 -7.3,7.1c0,5.4 3.1,9.3 7.3,9.3s7.3,-3.9 7.3,-9.3",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#DE2327",
    d: "m60.7,51.2c0,-3 -2.5,-5.5 -5.5,-5.5s-5.5,2.5 -5.5,5.5c0,4.2 2.3,7.3 5.5,7.3s5.5,-3 5.5,-7.3",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "#DE2327",
    d: "m36.8,71.4c0,-2.5 1.4,-4.8 3.5,-5.8c3,-1.5 7.9,-3.3 14.3,-3.4c-4.9,-0.3 -8.6,-4.9 -8.6,-11c0,-5.1 4.1,-9.2 9.2,-9.2s9.2,4.1 9.2,9.2c0,6.1 -3.7,10.7 -8.6,11c6.2,0.1 13.5,2.7 16.8,4.2c1.8,-0.3 3.8,-0.5 5.9,-0.5c-6,-0.3 -10.4,-5.8 -10.4,-13c0,-6 4.9,-10.8 11,-10.8s11,4.9 11,10.8c0,7.2 -4.4,12.7 -10.4,13c2.3,0 4.4,0.2 6.4,0.6c3.4,-1.6 10.1,-4.1 16.2,-4.2c-5,-0.3 -8.6,-4.9 -8.6,-11c0,-5.1 4.1,-9.2 9.2,-9.2s9.2,4.1 9.2,9.2c0,6 -3.7,10.7 -8.6,11c6.4,0.1 11.3,1.9 14.3,3.4c2.1,1 3.5,3.3 3.5,5.8l0,3l12.9,0c-5.2,-26.9 -28.4,-46.1 -56.2,-46.1s-50.9,19.2 -56.2,46.1l15.1,0l-0.1,-3.1l0,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#DE2327",
    d: "m108.3,51.2c0,-3 -2.5,-5.5 -5.5,-5.5s-5.5,2.5 -5.5,5.5c0,4.2 2.3,7.3 5.5,7.3s5.5,-3 5.5,-7.3",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#DE2327",
    d: "m62.6,69.2c1,-0.4 2.1,-0.9 3.4,-1.3c-3.3,-1 -7.3,-2 -10.8,-2c-6,0 -10.6,1.6 -13.3,3c-0.8,0.4 -1.4,1.4 -1.4,2.5l0,3l18.3,0c0.3,-2.3 1.7,-4.2 3.8,-5.2",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "#DE2327",
    d: "m93.9,72.6c-3.1,-1.4 -8.1,-3 -14.8,-3s-11.9,1.6 -15,3c-0.8,0.3 -1.3,1 -1.5,1.8l32.8,0c-0.2,-0.8 -0.7,-1.5 -1.5,-1.8",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "#DE2327",
    d: "m116.1,68.9c-2.8,-1.4 -7.4,-3 -13.3,-3c-3.5,0 -7.4,1 -10.6,2c1.2,0.4 2.3,0.8 3.2,1.3c2.1,0.9 3.5,2.9 3.7,5.2l18.4,0l0,-3c0,-1.1 -0.6,-2.1 -1.4,-2.5",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    fill: "#DE2327",
    d: "m58.9,74.4l-18.4,0l0,2.1l18.3,0l0,-1.4c0,-0.2 0,-0.5 0.1,-0.7",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    fill: "#DE2327",
    d: "m95.4,74.4l-32.8,0c-0.1,0.2 -0.1,0.5 -0.1,0.7l0,1.4l33,0l0,-1.4c0,-0.3 -0.1,-0.5 -0.1,-0.7",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    fill: "#DE2327",
    d: "m134.8,78.8l6.2,-0.6l-0.2,-1.7l-6.3,0c0,0.3 0.1,0.5 0.1,0.8l0.2,1.5z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_31",
    fill: "#DE2327",
    d: "m121.2,76.5l13.2,0c-0.1,-0.7 -0.2,-1.4 -0.4,-2.1l-12.9,0l0.1,2.1l0,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_32",
    fill: "#DE2327",
    d: "m36.8,76.5l0,-2.1l-15.1,0c-0.1,0.7 -0.3,1.4 -0.4,2.1l15.5,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    fill: "#DE2327",
    d: "m14.8,78.2l6.2,0.6l0.2,-1.6c0,-0.3 0.1,-0.5 0.1,-0.8l-6.3,0l-0.2,1.8z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    fill: "#DE2327",
    d: "m99.1,74.4c0,0.2 0,0.4 0,0.7l0,1.4l18.4,0l0,-2.1l-18.4,0z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_35",
    fill: "#DE2327",
    points: "66.4000015258789,0 60.30000305175781,16.39999771118164 47.5,21.39999771118164 31.099998474121094,14 14.699996948242188,29.699996948242188 22.5,45.29999542236328 17.099998474121094,57.69999694824219 0,63.5 0,73.0999984741211 4.400001525878906,73.0999984741211 4.400001525878906,66.4000015258789 20.5,60.900001525878906 27.199996948242188,45.19999694824219 19.900001525878906,30.5 32,19 47.30000305175781,25.89999771118164 63.80000305175781,19.39999771118164 69.5,4.099998474121094 86.5,4.099998474121094 92.19999694824219,19.39999771118164 108.60000610351562,25.89999771118164 124,19 136,30.5 128.6999969482422,45.19999694824219 135.5,60.900001525878906 151.5,66.4000015258789 151.5,73.0999984741211 155.89999389648438,73.0999984741211 155.89999389648438,63.5 138.89999389648438,57.69999694824219 133.5,45.29999542236328 141.3000030517578,29.699996948242188 124.89999389648438,14 108.5,21.39999771118164 95.69999694824219,16.39999771118164 89.60000610351562,0 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_36",
    fill: "#DE2327",
    height: 38.7,
    width: 135.4,
    className: "st1",
    y: 11.1,
    x: 219.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_37",
    fill: "#DE2327",
    height: 38.7,
    width: 38.7,
    className: "st1",
    y: 11.1,
    x: 177.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_39",
    fill: "#FFFFFF",
    d: "m243.9,38.4c2,0 3.6,-1.9 3.6,-4.3c0,-2.6 -1.4,-4.4 -3.6,-4.4c-2.3,0 -3.6,2 -3.6,4.2c0,2.6 1.4,4.5 3.6,4.5m9.5,4.1l-5.4,0l0,-3l-0.1,0c-0.8,1.9 -3.1,3.4 -5.8,3.4c-5.1,0 -7.8,-4.2 -7.8,-9.2c0,-4.2 2.6,-8.6 7.3,-8.6c2.4,0 4.3,0.6 5.8,2.6l0.1,0l0,-9.7l5.9,0l0,24.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_40",
    fill: "#FFFFFF",
    d: "m269.6,34c0,-2.5 -1.1,-4.8 -3.8,-4.8c-2.7,0 -3.8,2.3 -3.8,4.8s1.1,4.8 3.8,4.8c2.6,0 3.8,-2.3 3.8,-4.8m-13.8,0c0,-5.6 4.3,-8.9 9.9,-8.9s9.9,3.3 9.9,8.9s-4.3,8.9 -9.9,8.9c-5.6,0 -9.9,-3.3 -9.9,-8.9",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_41",
    fill: "#FFFFFF",
    d: "m278.2,25.5l5.4,0l0,3.1l0.1,0c1.2,-2.4 3.5,-3.5 6.2,-3.5c4.6,0 6.5,3.3 6.5,6.8l0,10.6l-5.9,0l0,-8.2c0,-3.2 -1.1,-4.3 -2.7,-4.3c-2.4,0 -3.7,1.7 -3.7,5.3l0,7.2l-5.9,0l0,-17z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_42",
    fill: "#FFFFFF",
    d: "m306.6,39c2.2,0 3.6,-2 3.6,-4c-0.8,0 -1.6,-0.1 -2.5,-0.1c-2,0 -3.6,0.6 -3.6,2.3c0,1.1 1.1,1.8 2.5,1.8m4,3.5c0,-0.9 -0.1,-1.8 -0.1,-2.7l-0.1,0c-1.3,2.1 -3,3.1 -5.4,3.1c-3.4,0 -6.4,-1.7 -6.4,-5.4c0,-5.2 5.6,-5.8 8.8,-5.8c0.9,0 2,0.1 2.7,0.2c0,-2.3 -1.8,-2.9 -3.9,-2.9c-1.9,0 -3.8,0.4 -5.4,1.3l-0.1,-4c2.1,-0.8 4.3,-1.2 6.8,-1.2c4.3,0 8.1,1.9 8.1,7.1l0,6.3c0,1.3 0.1,2.7 0.3,4c0,0 -5.3,0 -5.3,0z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_43",
    fill: "#FFFFFF",
    d: "m317.3,25.5l3.5,0l0,-3.8l5.8,-1.8l0,5.6l4.1,0l0,4.1l-4.1,0l0,6.3c0,2.1 0.5,3.1 2.4,3.1c0.6,0 1.2,-0.1 1.8,-0.2l0.2,3.8c-1.1,0.1 -2.2,0.3 -3.7,0.3c-5.3,0 -6.5,-2.3 -6.5,-6.4l0,-6.9l-3.4,0l-0.1,-4.1l0,0z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_44",
    fill: "#FFFFFF",
    d: "m333.6,25.5l5.9,0l0,17l-5.9,0l0,-17zm5.9,-2.8l-5.9,0l0,-4.3l5.9,0l0,4.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_45",
    fill: "#FFFFFF",
    points: "193.1999969482422,42.900001525878906 202.39999389648438,18.199996948242188 211.70001220703125,42.900001525878906 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_46",
    fill: "#FFFFFF",
    points: "199.8000030517578,18 190.60000610351562,42.79999542236328 181.3000030517578,18 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_48",
    fill: "#DE2327",
    d: "m206,105.1c-3.4,1 -6.9,1.6 -10,1.6c-11.8,0 -20.3,-7 -20.3,-21.3c0,-12 6.9,-20.7 20.2,-20.7c5.3,0 8.9,1.5 9.8,1.9l-0.6,9c-1.3,-0.8 -4.5,-2.3 -7.9,-2.3c-7,0 -10.2,4.5 -10.2,12.5c0,7 3.8,12.3 10.7,12.3c3.9,0 6.8,-1.6 7.8,-2.3l0.5,9.3z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_49",
    fill: "#DE2327",
    points: "211.39999389648438,65.4000015258789 222.39999389648438,65.4000015258789 222.39999389648438,97.70000457763672 235.79998779296875,97.70000457763672 235.79998779296875,105.99999237060547 211.39999389648438,105.99999237060547 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_50",
    fill: "#DE2327",
    points: "240.5,65.4000015258789 265.5,65.4000015258789 265.5,73.4000015258789 251.29998779296875,73.4000015258789 251.29998779296875,81.19999694824219 264.79998779296875,81.19999694824219 264.79998779296875,89.19999694824219 251.29998779296875,89.19999694824219 251.29998779296875,97.99999237060547 266.20001220703125,97.99999237060547 266.20001220703125,105.99999237060547 240.5,105.99999237060547 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_51",
    fill: "#DE2327",
    points: "268.5,65.4000015258789 280.1000061035156,65.4000015258789 286.6000061035156,94.5 286.70001220703125,94.5 293.3999938964844,65.4000015258789 304.5,65.4000015258789 292.3999938964844,105.99999237060547 280.6000061035156,105.99999237060547 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_52",
    fill: "#DE2327",
    points: "308.5,65.4000015258789 333.3999938964844,65.4000015258789 333.3999938964844,73.4000015258789 319.20001220703125,73.4000015258789 319.20001220703125,81.19999694824219 332.70001220703125,81.19999694824219 332.70001220703125,89.19999694824219 319.20001220703125,89.19999694824219 319.20001220703125,97.99999237060547 334.20001220703125,97.99999237060547 334.20001220703125,105.99999237060547 308.5,105.99999237060547 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_54",
    fill: "#DE2327",
    d: "m353.5,82.3c2.3,0 4.5,-1.7 4.5,-4.4c0,-2.8 -1.5,-4.8 -4.7,-4.8l-3,0l0,9.1l3.2,0l0,0.1zm2.4,12.2c-1,-3.9 -2.9,-4.4 -4.6,-4.4l-0.6,0l0,15.9l-10.9,0l0,-40.6l16.2,0c8.2,0 12.9,3.4 12.9,10.9c0,6 -4.3,8.4 -7.8,9.3l0,0.2c2.3,0.8 3.8,1.9 5.5,7.5l3.7,12.7l-11.3,0l-3.1,-11.5z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_55",
    fill: "#FFFFFF",
    d: "m206,153.6c-3.4,1 -6.9,1.6 -10,1.6c-11.8,0 -20.3,-7 -20.3,-21.3c0,-12 6.9,-20.7 20.2,-20.7c5.3,0 8.9,1.5 9.8,1.9l-0.6,9c-1.3,-0.8 -4.5,-2.3 -7.9,-2.3c-7,0 -10.2,4.5 -10.2,12.5c0,7 3.8,12.3 10.7,12.3c3.9,0 6.8,-1.6 7.8,-2.3l0.5,9.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_56",
    fill: "#FFFFFF",
    d: "m221.9,139.6c-0.1,4.5 1,7.6 4.8,7.6s4.8,-3.1 4.8,-7.6l0,-25.7l10.7,0l0,25.4c0,11.9 -6.9,16 -15.5,16s-15.5,-4.1 -15.5,-16l0,-25.4l10.7,0l0,25.7z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_57",
    fill: "#FFFFFF",
    d: "m249.3,144.7c1.3,0.8 5.3,2.4 9.2,2.4c4.1,0 5.6,-1.8 5.6,-4.4c0,-2.7 -1.8,-3.4 -5,-4.7l-2.4,-0.9c-6.7,-2.6 -8.7,-6.2 -8.7,-12c0,-7.7 6.2,-12.1 14.8,-12.1c3.1,0 6.9,0.3 10.3,1.6l-0.5,8c-1.9,-1 -5.2,-2 -8.4,-2c-3.3,0 -5.2,1.3 -5.2,3.8c0,2.1 1,3 4.7,4.7l4.9,2.2c3.7,1.7 6.9,4.3 6.9,10.3c0,8.9 -6.4,13.5 -15.9,13.5c-4.9,0 -8.8,-1 -10.8,-1.6l0.5,-8.8z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_58",
    fill: "#FFFFFF",
    points: "278.70001220703125,113.9000015258789 278.70001220703125,122.0999984741211 287.5,122.0999984741211 287.5,154.49999237060547 298.3999938964844,154.49999237060547 298.3999938964844,122.0999984741211 307.20001220703125,122.0999984741211 307.20001220703125,113.9000015258789 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_60",
    fill: "#FFFFFF",
    d: "m327.4,147.4l0,0c4.7,0 6.9,-5.2 6.9,-13.2c0,-7.9 -2.2,-13.2 -6.8,-13.2c-4.7,0 -6.9,5.3 -6.9,13.2c0,8 2.2,13.2 6.8,13.2m0.1,-34.2c8.9,0 18.1,5.9 18.1,21s-9.2,21 -18.1,21s-18.1,-5.9 -18.1,-21s9.2,-21 18.1,-21",
    className: "st0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_61",
    fill: "#FFFFFF",
    points: "379.29998779296875,113.9000015258789 373.29998779296875,139.4000015258789 373.20001220703125,139.4000015258789 367.79998779296875,113.9000015258789 351.70001220703125,113.9000015258789 351.70001220703125,154.49999237060547 361.20001220703125,154.49999237060547 361.20001220703125,123.5999984741211 361.29998779296875,123.5999984741211 369.5,154.49999237060547 376.3999938964844,154.49999237060547 385.1000061035156,123.5999984741211 385.20001220703125,123.5999984741211 385.20001220703125,154.49999237060547 395,154.49999237060547 395,113.9000015258789 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_62",
    fill: "#FFFFFF",
    points: "402.29998779296875,113.9000015258789 402.29998779296875,154.49999237060547 428,154.49999237060547 428,146.49999237060547 413,146.49999237060547 413,137.70000457763672 426.6000061035156,137.70000457763672 426.6000061035156,129.70000457763672 413,129.70000457763672 413,121.9000015258789 427.29998779296875,121.9000015258789 427.29998779296875,113.9000015258789 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_64",
    fill: "#FFFFFF",
    d: "m447.3,130.8c2.3,0 4.5,-1.7 4.5,-4.4c0,-2.8 -1.5,-4.8 -4.7,-4.8l-3,0l0,9.1l3.2,0.1l0,0zm2.4,12.2c-1,-3.9 -2.9,-4.4 -4.6,-4.4l-0.6,0l0,15.9l-10.9,0l0,-40.6l16.2,0c8.2,0 12.9,3.4 12.9,10.9c0,6 -4.3,8.4 -7.8,9.3l0,0.2c2.3,0.8 3.8,1.9 5.5,7.5l3.7,12.7l-11.3,0l-3.1,-11.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_65",
    fill: "#FFFFFF",
    d: "m496.7,132.5c2.9,0 5.1,-2 5.1,-5.3c0,-3.8 -2,-5.5 -5.4,-5.5l-1.6,0l0,10.8l1.9,0zm-1.5,22l-10.9,0l0,-40.6l13.5,0c8.4,0 14.9,3.2 14.9,13.5c0,8.2 -5.2,13 -12.9,13l-4.5,0l-0.1,14.1l0,0z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_66",
    fill: "#FFFFFF",
    d: "m534.4,147.4l0,0c4.7,0 6.9,-5.2 6.9,-13.2c0,-7.9 -2.2,-13.2 -6.8,-13.2c-4.7,0 -6.9,5.3 -6.9,13.2c0,8 2.2,13.2 6.8,13.2m0.1,-34.2c8.9,0 18.1,5.9 18.1,21s-9.2,21 -18.1,21c-8.9,0 -18.1,-5.9 -18.1,-21c0.1,-15.1 9.3,-21 18.1,-21",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_67",
    fill: "#FFFFFF",
    d: "m572.4,130.8c2.3,0 4.5,-1.7 4.5,-4.4c0,-2.8 -1.5,-4.8 -4.7,-4.8l-3,0l0,9.1l3.2,0.1l0,0zm2.4,12.2c-1,-3.9 -2.9,-4.4 -4.6,-4.4l-0.6,0l0,15.9l-10.9,0l0,-40.6l16.2,0c8.2,0 12.9,3.4 12.9,10.9c0,6 -4.2,8.4 -7.8,9.3l0,0.2c2.3,0.8 3.8,1.9 5.5,7.5l3.7,12.7l-11.3,0l-3.1,-11.5z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_68",
    fill: "#FFFFFF",
    points: "591.5,113.9000015258789 591.5,122.0999984741211 600.2000122070312,122.0999984741211 600.2000122070312,154.49999237060547 611.0999755859375,154.49999237060547 611.0999755859375,122.0999984741211 619.9000244140625,122.0999984741211 619.9000244140625,113.9000015258789 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_69",
    fill: "#FFFFFF",
    d: "m638.1,122.1l0,0l3.7,16l-8,0l4.3,-16zm-5.8,-8.2l-13.5,40.6l10.5,0l2.6,-8.6l11.9,0l2.2,8.6l11.3,0l-12.9,-40.6l-12.1,0l0,0z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_70",
    fill: "#FFFFFF",
    points: "661.0999755859375,113.9000015258789 661.0999755859375,154.49999237060547 685.5,154.49999237060547 685.5,146.20000457763672 672.0999755859375,146.20000457763672 672.0999755859375,113.9000015258789 ",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonatiClever);
export default __webpack_public_path__ + "static/media/donati-clever.84956fa83581e69f31cfd8a76ef2411e.svg";
export { ForwardRef as ReactComponent };